export default __webpack_public_path__ + "static/media/img-step-a-bg-1.e85d7de5.jpg";